import clsx from 'clsx'

type Props = {
	title: string
	showMenu: boolean
	showRef: React.RefObject<HTMLDivElement>
	children: React.ReactNode
}

export const FilterMenu = ({ title, showMenu, showRef, children }: Props) => {
	return (
		<>
			<div
				className={clsx(
					showMenu ? 'translate-x-0 z-30' : '-translate-x-full',
					'w-full max-w-[600px] mr-6 absolute top-0 left-0 lg:relative lg:translate-x-0 transition-all'
				)}
			>
				<div
					className="z-30 w-4/5 lg:w-full h-screen lg:h-full p-6 lg:p-1 bg-white lg:bg-transparent overflow-y-auto"
					ref={showRef}
				>
					<h1 className="text-bc-black text-lg font-bold mb-6">{title}</h1>

					{children}
				</div>
			</div>

			{/* Mobile Filter Overlay */}
			<div
				className={clsx(
					showMenu ? 'block' : 'hidden',
					'opacity-50 z-20 top-0 w-full lg:hidden h-screen bg-bc-black absolute right-0 transition-all'
				)}
			/>
		</>
	)
}
